import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  inject,
} from '@angular/core';
import { TreeFormIcon } from './TreeFormIcon';
import { OtherIcons } from './OtherIcons';
import { TreeFormData } from '../TreeFormData';
import { AsyncPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TreeDialogMode } from '../TreeDialogMode';

@Component({
  selector: 'app-tree-form-icon-select',
  templateUrl: './tree-form-icon-select.component.html',
  styleUrl: './tree-form-icon-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, AsyncPipe],
})
export class TreeFormIconSelectComponent implements AfterViewInit {
  private cdr = inject(ChangeDetectorRef);

  @Input({ required: true }) data: TreeFormData;

  defaultIcon: TreeFormIcon;

  icons: TreeFormIcon[] = [];

  ngAfterViewInit() {
    this.setDefaultIcon();
    this.icons = [this.defaultIcon, ...OtherIcons.filter((o) => o != this.defaultIcon)].filter(
      Boolean,
    );
    this.data.icon$.next(this.defaultIcon);
    if (this.data.item && this.data.mode == TreeDialogMode.Edit)
      this.data.icon$.next(this.data.item.icon);
    if (!this.data.icon$.value) this.selectIcon(this.defaultIcon);
    this.cdr.detectChanges();
  }

  private setDefaultIcon() {
    this.defaultIcon = this.data.typeSelected$?.value?.icon ?? this.data?.item?.icon ?? '';
  }

  selectIcon(icon: TreeFormIcon) {
    this.data.icon$.next(icon);
    this.cdr.detectChanges();
  }
}
